import { render, staticRenderFns } from "./login_phone.vue?vue&type=template&id=f2c140cc"
import script from "./login_phone.vue?vue&type=script&lang=js"
export * from "./login_phone.vue?vue&type=script&lang=js"
import style0 from "./login_phone.vue?vue&type=style&index=0&id=f2c140cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports